import { render, staticRenderFns } from "./CompanyReportColumn.vue?vue&type=template&id=88aee192&scoped=true"
import script from "./CompanyReportColumn.vue?vue&type=script&lang=js"
export * from "./CompanyReportColumn.vue?vue&type=script&lang=js"
import style0 from "./CompanyReportColumn.vue?vue&type=style&index=0&id=88aee192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88aee192",
  null
  
)

export default component.exports